(function () {
    'use strict';

    angular
        .module('elogbooks.admin.missed-patrol-reasons')
        .controller('ReasonAddEditController', ReasonAddEditController);

    function ReasonAddEditController($state, apiClient, messenger, confirmationModal, reasonResponse, requestDataFactory) {
        var vm = this;
        vm.reason = reasonResponse;
        vm.data = requestDataFactory.createRequest(vm.reason);

        vm.create = createAction;
        vm.update = updateAction;
        vm.delete = deleteAction;

        function createAction() {
            return apiClient.create(reasonResponse.getLink('reasons'), vm.data).then(function (response) {
                if (response) {
                    $state.go('^', {}, {reload: $state.current.parent}).then(function () {
                        messenger.success('MISSED_PATROL_REASON_ADDED');
                    });
                } else {
                    messenger.error('REQUEST_ERROR');
                }
            });
        }

        function updateAction() {
            return apiClient.update(reasonResponse.getLink('edit'), vm.data).then(function (response) {
                if (response) {
                    $state.go('^', {}, {reload: $state.current.parent}).then(function () {
                        messenger.success('MISSED_PATROL_REASON_UPDATED');
                    });
                } else {
                    messenger.error('REQUEST_ERROR');
                }
            });
        }

        function deleteAction() {
            return confirmationModal.open().result.then(function () {
                return apiClient.delete(reasonResponse.getLink('delete')).then(function (response) {
                    if (response) {
                        $state.go('^', {}, {reload: $state.current.parent}).then(function () {
                            messenger.success('MISSED_PATROL_REASON_DELETED');
                        });
                    } else {
                        messenger.error('REQUEST_ERROR');
                    }
                });
            });
        }
    }
})();
